import axios from "../http";
import { handleGetRequestParams } from '../common/js/util'

class Team {
  // 组长列表
  static getHeadmanList(option) {
    let url = `/oa/api/team/group/page?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 组长管理详情
  static getHeadmanDetails(option) {
    let url = `/oa/api/team/group/detail?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 更新状态
  static postUpdateHeadmanStatus(data) {
    const url = `/oa/api/team/group/update/status`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 新增组长
  static postAddHeadmanManage(data) {
    const url = `/oa/api/team/group/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑组长
  static postUpdateHeadmanManage(data) {
    const url = `/oa/api/team/group/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 删除组长
  static postDelHeadmanManage(data) {
    const url = `/oa/api/team/group/delete`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 创建班组二维码
  static postAddTeamQrCode(data) {
    const url = `/oa/api/production/line/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑班组二维码
  static postModTeamQrCode(data) {
    const url = `/oa/api/production/line/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 更新班组二维码状态
  static postUpdateTeamQrCodeStatus(data) {
    const url = `/oa/api/production/line/update/status`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 班组二维码列表
  static getTeamQrCodeList() {
    const url = `/oa/api/production/line/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 班组仓库列表
  static getTeamGroupList(date) {
    const url = `/oa/api/team/group/detail/warehouse/list?date=${date}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 组员列表
  static getTeamMembersList(option) {
    let url = `/oa/api/team/group/detail/member/list?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 待分配组员列表
  static getToBeAllocatedList(option) {
    let url = `/oa/api/team/group/detail/not/allocated/list?`;
    url += handleGetRequestParams(option)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 移至待分配
  static postMoveToBeAllocated(data) {
    const url = `/oa/api/team/group/move/not/allocated`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Team;